const ALLOWED_SMS_URL_DOMAIN = 'mysmartguest.com';
const PROTOCOL_OR_WWW_URL_PATTERN = /(?:https?:\/\/|www\.)[^\s<>"']+/gi;
const BARE_COM_OR_PL_DOMAIN_PATTERN =
  /\b(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:com|pl)(?:\/[^\s<>"']*)?/gi;
const TRAILING_PUNCTUATION_PATTERN = /[.,;:!?)\]}>]+$/;

/**
 * Removes trailing punctuation commonly attached to URLs in SMS text.
 */
export function trimUrlTrailingPunctuation(url: string): string {
  return url.replace(TRAILING_PUNCTUATION_PATTERN, '');
}

/**
 * Extracts http(s)/www URLs and bare .com / .pl domains from plain text.
 */
export function extractUrlsFromText(text: string): string[] {
  if (!text) {
    return [];
  }
  const protocolOrWwwUrls = [...(text.match(PROTOCOL_OR_WWW_URL_PATTERN) ?? [])].map(trimUrlTrailingPunctuation);
  const bareDomains = [...(text.match(BARE_COM_OR_PL_DOMAIN_PATTERN) ?? [])]
    .map(trimUrlTrailingPunctuation)
    .filter(bareDomain => !protocolOrWwwUrls.some(url => url.includes(bareDomain)));
  return [...new Set([...protocolOrWwwUrls, ...bareDomains])];
}

/**
 * Returns true when hostname is mysmartguest.com or any subdomain.
 */
export function isAllowedMysmartguestHost(hostname: string): boolean {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  return host === ALLOWED_SMS_URL_DOMAIN || host.endsWith(`.${ALLOWED_SMS_URL_DOMAIN}`);
}

/**
 * Returns true when plain SMS text contains at least one URL outside the allowed domain.
 */
export function hasDisallowedSmsUrl(plainText: string): boolean {
  return extractUrlsFromText(plainText).some(url => {
    try {
      const normalized = /^https?:\/\//i.test(url) ? url : `https://${url}`;
      const { hostname } = new URL(normalized);
      return !isAllowedMysmartguestHost(hostname);
    } catch {
      return true;
    }
  });
}
